import { STATS_COLUMNS_FOR_CATEGORY } from 'widgets/statspro/js/components/common/config/columns';

export const composeRows = (seasonNavId, category) => {
    return [
        ...STATS_COLUMNS_FOR_CATEGORY[category].map((col) => ({
            name: col.name,
            accessor: col.id
        }))
    ];
};
